/**
 * ResultLabels — display copy for the dice-result flyout.
 *
 * Each result type maps to one or more variant strings; the picker chooses
 * one at random per call so the same outcome doesn't read the same way
 * round after round. Returns `null` when no label should be shown (cee-lo
 * NOTHING re-roll, craps continue point-roll).
 *
 * Templates use `{N}` for substitution — currently the point/value number.
 */
import { CeeloResultType } from '../state-machine/GameStates.js';
// ============================================================================
// CEE-LO
// ============================================================================
const CEELO_LABELS = {
    [CeeloResultType.CEELO]: ['CEE-LO!', '4-5-6!', 'Insta-Win!'],
    [CeeloResultType.TRIPS_6]: ['Triple Sixes!', 'Big Trips!', "Devil's Trips!"],
    [CeeloResultType.TRIPS]: ['Trips {N}s!', 'Three {N}s!', '{N}-{N}-{N}!'],
    [CeeloResultType.PAIR]: ['Point {N}', 'Pair — {N}'],
    [CeeloResultType.ACE]: ['Ace-Deuce-Trey!', '1-2-3!', 'Insta-Loss!'],
    [CeeloResultType.NOTHING]: [],
};
export function pickCeeloLabel(result) {
    const variants = CEELO_LABELS[result.type];
    if (!variants || variants.length === 0)
        return null;
    const tmpl = pickOne(variants);
    return tmpl.replace(/\{N\}/g, String(result.value));
}
// ============================================================================
// CRAPS — COME-OUT
// ============================================================================
const CRAPS_NATURAL_7 = ['Natural 7!', 'Lucky Seven!', 'Front Line Winner!'];
const CRAPS_NATURAL_11 = ['Yo-Eleven!', 'Yo!', 'Eleven!'];
const CRAPS_SNAKE_EYES = ['Snake Eyes!', 'Aces — Craps!', 'Crapped Out!'];
const CRAPS_ACE_DEUCE = ['Ace-Deuce!', 'Three Craps!'];
const CRAPS_BOXCARS = ['Boxcars!', 'Midnight!', 'Twelve Craps!'];
const CRAPS_POINT_SET = ['Point is {N}', 'Mark the {N}', 'Working the {N}'];
export function pickCrapsComeOutLabel(outcome) {
    switch (outcome.kind) {
        case 'natural':
            return outcome.total === 7 ? pickOne(CRAPS_NATURAL_7) : pickOne(CRAPS_NATURAL_11);
        case 'craps':
            if (outcome.total === 2)
                return pickOne(CRAPS_SNAKE_EYES);
            if (outcome.total === 3)
                return pickOne(CRAPS_ACE_DEUCE);
            return pickOne(CRAPS_BOXCARS);
        case 'point':
            return pickOne(CRAPS_POINT_SET).replace(/\{N\}/g, String(outcome.point));
    }
}
// ============================================================================
// CRAPS — POINT-ROLL
// ============================================================================
const CRAPS_POINT_HIT = ['Made the {N}!', 'Hit the {N}!', 'Pass!'];
const CRAPS_SEVEN_OUT = ['Seven Out!', 'Line Away!', 'Out on Seven!'];
export function pickCrapsPointLabel(outcome, point) {
    switch (outcome.kind) {
        case 'point_hit':
            return pickOne(CRAPS_POINT_HIT).replace(/\{N\}/g, String(point));
        case 'seven_out':
            return pickOne(CRAPS_SEVEN_OUT);
        case 'continue':
            return null;
    }
}
// ============================================================================
// INTERNAL
// ============================================================================
function pickOne(arr) {
    return arr[Math.floor(Math.random() * arr.length)];
}
//# sourceMappingURL=ResultLabels.js.map